var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMapPin20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M9.857 2C6.086 2 3 5 3 8.667c0 4.933 6.24 9.066 6.446 9.2.137.066.274.133.411.133.137 0 .274-.067.412-.133.205-.134 6.445-4.267 6.445-9.2C16.714 5 13.63 2 9.857 2zm0 14.533c-1.303-.933-5.486-4.266-5.486-7.866 0-2.934 2.469-5.334 5.486-5.334s5.486 2.4 5.486 5.334c0 3.6-4.183 6.933-5.486 7.866zM9.857 6C8.35 6 7.114 7.2 7.114 8.667c0 1.466 1.235 2.666 2.743 2.666 1.509 0 2.743-1.2 2.743-2.666C12.6 7.2 11.366 6 9.857 6zm0 4c-.754 0-1.371-.6-1.371-1.333 0-.734.617-1.334 1.371-1.334s1.372.6 1.372 1.334C11.229 9.4 10.61 10 9.857 10z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#989898",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#2A394D",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMapPin20);
export default __webpack_public_path__ + "static/media/ic-map-pin-20.c0223dbade7cda3c4cc6dcfd16632bed.svg";
export { ForwardRef as ReactComponent };